export interface TranslationFields extends Record<string, string> {
  name_fr: string
  name_en: string
}

export enum LanguageCode {
  EN = 'en',
  FR = 'fr',
}

export enum FlagIso {
  FR = 'fr',
  GB = 'gb',
}

export type TranslatedFields = Partial<Record<LanguageCode, string | null>>
